import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import callReducer from "../features/call/callSlice";
import notificationReducer from "../features/notification/notificationSlice";
import messageReducer from "../features/message/messageSlice";
import uiReducer from "../features/ui/uiSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    call: callReducer,
    notification: notificationReducer,
    message: messageReducer,
    ui: uiReducer,
  },
});